import { atom } from 'recoil';
import { LegacyAppointment } from '../../interfaces/api/Collaborative';

export default atom({
  key: 'appointments',
  default: {} as { [key: string]: LegacyAppointment },
});
